import Big from 'big.js'

import { CryptoToBigParams } from './types'
import { countDecimals } from '../../common/countDecimals'
import { removeTrailingZeros } from '../../common/removeTrailingZeros'

const MAX_CRYPTO_DECIMALS = 18

export const cryptoToBig = ({
  amount = 0,
  decimals: customDecimals,
  shouldRemoveTrailingZeros,
  keepFullPrecision,
}: CryptoToBigParams): string => {
  const safeAmount = amount ?? 0

  const bigAmount = new Big(safeAmount)

  if (keepFullPrecision) {
    return bigAmount.toString()
  }

  const originalDecimals = countDecimals(safeAmount)

  const targetDecimals = Math.min(
    customDecimals ?? originalDecimals,
    MAX_CRYPTO_DECIMALS,
  )

  const formattedAmount = bigAmount.toFixed(targetDecimals, 0)

  return shouldRemoveTrailingZeros
    ? removeTrailingZeros(formattedAmount)
    : formattedAmount
}
